import { Component, OnInit, ViewChild, Inject, ViewContainerRef, HostListener } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router  } from '@angular/router';
import { DatePipe, Location } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DetailRowService, GridModel, GridComponent, SelectionSettingsModel, ToolbarItems, PageSettingsModel, GroupSettingsModel, RowDataBoundEventArgs } from '@syncfusion/ej2-angular-grids';
import { Observable } from 'rxjs';
import { CanDeactivateGuard } from '../../../../src/app/shared/canDeactivateGuard';
import { debounceTime, distinctUntilChanged, filter, finalize, switchMap, tap } from 'rxjs/operators';
import { isNumber } from 'highcharts';
import { MatAutocomplete } from '@angular/material/autocomplete';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { TipoMaterialService, MenuFuncionService, ComunidadService, PedidoService, IncidenciaUsuarioService, MonedaService, ProveedorService } from '../../../../src/app/shared/services/index';
import { Comunidad, MenuFuncionCodes,  PedidoDto, SearchComunidadRequest, SearchTipoMaterialRequest, TipoMaterialDto, DialogAgregarPresupuesto, AprobarPedidoDto, PedidoPresupuestoDetalle,  DialogAgregarComparativa, SearchMonedaRequest, SearchProveedorRequest, Proveedor, SavePedidoPlanificacionDto, SavePedidoPlanificacionItemDto, ModalPedidoItemsDto, GridPageSettings,
  SavePedidoPresupuestoSeleccion, Moneda, SavePedidoHistorialDto,PedidoRemito, PedidoRemitoDetalle, PedidoEntregasResponseDto, IncidenciaUsuario, SearchIncidenciaUsuarioRequestDto, PedidoComunidadRolConstants,
  ModalPedidoItemDto, PedidoItemDto, DialogConfirmRequest, PedidoHistorialDto, DialogConfirmResponse, PedidoPresupuesto, PedidoPermisosDto, PedidoEstadoChangeDto, EstadoConstants
 } from '../../../../src/app/shared/model';

import { DialogConfirmComponent } from '../../../../src/app/shared/components/modals/dialogConfirm.component';
import { DialogModificarPedidoItemComponent } from './components/dialogModificarPedidoItem.component';
import { DialogAgregarPresupuestoComponent } from './components/dialog-agregar-presupuesto.component';
import { DialogAgregarComparativaComponent } from './components/dialogAgregarComparativa.component';
import { DialogVerRemitoComponent } from './components/dialogVerRemito.component';
import { DialogFechaMasivaMaterialComponent } from './components/dialog-fecha-masiva-material.component';

@Component({
  selector: 'app-pedidoEdit',
  templateUrl: './pedidoEdit.component.html',
  styleUrls: ['./pedidoEdit.component.scss'],
  providers: [ DetailRowService ]
})

export class PedidoEditComponent implements OnInit, CanDeactivateGuard {

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    var cambiosPendientesLista = this.getCambiosPendientes();
    if (cambiosPendientesLista != null && cambiosPendientesLista.length > 0) {

      const message = "Realizó cambios que todavía no fueron guardados en las siguientes secciones: " +
        (cambiosPendientesLista.join(', ')) + ". " +
        "Si continúa, perderá los cambios realizados. ¿Desea continuar y descartar los cambios?";

      $event.returnValue = message;
      // return message;
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    return this.pedirConfirmacionDescarteCambios().then((result: DialogConfirmResponse) => {
      return (result != null && result.Accepted);
    })
  }

// #region Variables
  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('pedidoItemGrid')
  public pedidoItemGrid: GridComponent;
  @ViewChild('pedidoItemPlanificacionGrid')
  public pedidoItemPlanificacionGrid: GridComponent;

  @ViewChild('presupuestoSeleccionChildTemplate')
  public presupuestoSeleccionChildTemplate: any;
  @ViewChild('remitoAccionChildTemplate')
  public remitoAccionChildTemplate: any;

  @ViewChild('gridPresupuestos')
  public gridPresupuestos: GridComponent;
  @ViewChild('gridPresupuestosDetalle')
  public gridPresupuestosDetalle: GridComponent;

  @ViewChild('gridEntregasPorProveedor')
  public gridEntregasPorProveedor: GridComponent;

  comunidadOrigenList: Comunidad[] = [];
  formGroup: FormGroup;
  formFileGroup: FormGroup;
  pedidoHistorialFormGroup: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isSaving: boolean = false;
  isTipoMaterialSearching: boolean = false;
  isComunidadOrigenSearching: boolean = false;
  isComunidadDestinoSearching: boolean = false;
  isDeleting: boolean = false;
  isPedidoHistorialSearching: boolean = false;
  isPedidoAprobacionesSearching: boolean = false;
  isPedidoItemsSearching: boolean = false;
  isPresupuestoSearching: boolean = false;
  isUnidadMedidaSearching: boolean = false;
  isPedidoEntregasSearching: boolean = false;
  isPresupuestoItemsSearching: boolean = false;
  isSavingPresupuestoSeleccion: boolean = false;
  isSavingPedidoHistorial: boolean = false;
  isSavingMaterial: boolean = false;
  isSavingAdjunto: boolean = false;

  isFileAttaching: boolean = false;
  isFileDeleting: boolean = false;
  isAttachmentSearching: boolean = false;
  isSavingPlan: boolean = false;
  isAprobando: boolean = false;
  isRechazando: boolean = false;
  isEnviandoPresupuestar: boolean = false;
  isEnviandoRevision: boolean = false;
  isEnviandoPendienteEntrega: boolean = false;
  isEnviandoPendienteCoordinacion: boolean = false;
  isEnviandoEntregado: boolean = false;
  isEnviandoFinalizado: boolean = false;
  isMonedaSearching: boolean = false;
  isProveedorPlanificacionAutoSearching: boolean = false;
  isRemitoSearching: boolean = false;
  isPedidoIncidenciasSearching: boolean = false;
  verSoloDetallesPresupuestos: boolean = false;
  hayPendientesEntrega: boolean = false;

  obraSeleccionada: boolean = false;
  seleccionoFamiliaMaterial: boolean = false;
  canHacerPrestamos: boolean = false;

  monedaList: Moneda[];
  tipoMaterialList: TipoMaterialDto[] = [];
  comunidadDestinoList: Comunidad[] = [];
  pedidoHistorialDtoList: PedidoHistorialDto[] = [];

  pedidoEntregasDto: PedidoEntregasResponseDto | null = null;
  pedidoEntregaAgrupador: string = "";

  presupuestoList: PedidoPresupuesto[];
  presupuestoDetalleList: PedidoPresupuestoDetalle[];

  remitoList: PedidoRemito[];
  remitoDetalleList: PedidoRemitoDetalle[];

  pedidoIncidenciasList: IncidenciaUsuario[];

  itemPlanificacionList: SavePedidoPlanificacionItemDto[];

  aprobacionCoordinador: any = null;
  aprobacionCoordinadorGeneral: any = null;
  aprobacionCeo: any = null;

  pedidoHistorialMsgError: string = "";
  pedidoEntregasMsgError: string = "";
  presupuestosMsgError: string = "";
  remitosMsgError: string = "";
  pedidoIncidenciasMsgError: string = "";
  msgError: string = "";

  item: PedidoDto;
  itemTable: PedidoDto[] = [];
  itemPedido: PedidoItemDto;
  pedidoId: number = 0;

  public presupuestoGroupOptions: GroupSettingsModel;
  public presupuestoChildGrid: GridModel;

  public remitoChildGrid: GridModel;

  public entregasPorProveedorChildGrid: GridModel;
  public entregasPorMaterialChildGrid: GridModel;

  public pedidoPermisos: PedidoPermisosDto;
  pedidoPresupuestoId: number = 0;
  public newFileDescripcion: string = "";

  public minDate = new Date();

  //grid config
  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  //flag para validar si hay cambios
  // cambios en formularios
  public cambioPendientePedido = false;
  public cambioPendienteHistorialPedido = false;
  // cambios en listas
  public cambioPendienteMaterial = false;
  public cambioPendientePlanificacion = false;
  public cambioPendientePresupuesto = false;
  public cambioPendienteRemitos  = false;
  public cambioPendienteAdjuntos  = false;

  //#endregion

  constructor (
    private formBuilder: FormBuilder,
    private location: Location,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private sharedFunctions: SharedFunctions,
    private route: ActivatedRoute,
    private router: Router,
    private menuService: MenuFuncionService,
    private comunidadService: ComunidadService,
    private tipoMaterialService: TipoMaterialService,
    private incidenciaUsuarioService: IncidenciaUsuarioService,
    private pedidoService: PedidoService,
    private monedaService: MonedaService,
    private proveedorService: ProveedorService,
    @Inject(ViewContainerRef) private viewContainerRef?: ViewContainerRef) {
  }

  ngOnInit(): void {
    this.isValidating = true;
    this.pedidoPermisos = new PedidoPermisosDto(false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false,false, false, false, false);

    this.menuService.checkMenuPadre(MenuFuncionCodes.PEDIDO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result) {
        var canView = data.Result.some(f => f == MenuFuncionCodes.PEDIDO_LIST || f == MenuFuncionCodes.COMPRAS_LIST);
        if (canView) {
          this.canHacerPrestamos = data.Result.some(f => f == MenuFuncionCodes.PEDIDO_PERMISO_PRESTAMO);
          this.loadView();
        }
        else {
          this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
          this.onCancel();
        }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.onCancel();
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  pedirConfirmacionDescarteCambios() : Promise<DialogConfirmResponse> {
    var cambiosPendientesLista = this.getCambiosPendientes();

    if (cambiosPendientesLista != null && cambiosPendientesLista.length > 0) {
      return new Promise((resolve, reject) => {
        var msg = "Realizó cambios que todavía no fueron guardados en las siguientes secciones: " +
          (cambiosPendientesLista.join(', ')) + ". " +
          "<br/><b>Si continúa, perderá los cambios realizados.</b><br/><br/>¿Desea continuar y descartar los cambios?";

        const dialogRef = this.dialog.open(DialogConfirmComponent, {
          data: new DialogConfirmRequest(
            "Confirmar Descartar Cambios Pendientes",
            msg,
            "Sí, descarta los cambios",
            "No los descartes"
          )
        })

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
          //Si desea descartar los cambios, reseteo los flags
          if (result != null && result.Accepted)
            this.resetCambiosPendientes();
          resolve(result);
        });
      });
    }

    return new Promise((resolve, reject) => { resolve(new DialogConfirmResponse(true)); });
  }

  resetCambiosPendientes() {
    this.cambioPendientePedido = false;
    this.cambioPendienteMaterial = false;
    this.cambioPendientePlanificacion = false;
    this.cambioPendientePresupuesto = false;
    this.cambioPendienteRemitos = false;
    this.cambioPendienteAdjuntos = false;
    this.cambioPendienteHistorialPedido = false;
  }

  getCambiosPendientes(): string[] {
    var r : string[]= [];

    if (this.cambioPendientePedido) r.push("Datos del Pedido");
    if (this.cambioPendienteMaterial) r.push("Materiales");
    if (this.cambioPendientePlanificacion) r.push("Planificación");
    if (this.cambioPendientePresupuesto) r.push("Presupuestos");
    if (this.cambioPendienteRemitos) r.push("Remitos");
    if (this.cambioPendienteAdjuntos) r.push("Adjuntos del Pedido");
    if (this.cambioPendienteHistorialPedido) r.push("Historial");

    return r;
  }

// #region Loading

  loadView() {
    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.buildForm();
    this.buildFileForm();
    this.buildPedidoHistorialFormGroup();

    this.loadEntity();

    this.getComunidadesOrigen();
    this.getComunidadesDestino();
    this.getTipoMaterial();
  }

  cambiosFormPedido() {
    this.formGroup.valueChanges.subscribe(() => {
      this.cambioPendientePedido = true;
    });
  }

  cambiosFormHistorialPedido() {
    this.pedidoHistorialFormGroup.valueChanges.subscribe(() => {
      this.cambioPendienteHistorialPedido = true;
    });
  }

  detectarCambioCheckItemPagado() {
    this.cambioPendientePedido = true;
  }

  cambioAdjuntos() {
    this.cambioPendienteAdjuntos = true;
  }

  cambioHistorial() {
    this.cambioPendienteHistorialPedido = true;
  }

  loadEntity() {
    this.route.params.subscribe(params => {
      if (params['id'] != null && params['id'] != '0') {
        this.pedidoId = Number(params['id']);

        if (this.pedidoId > 0) {
          this.isSearching = true;
          this.pedidoService.get(this.pedidoId).subscribe(data => {
            if (data != null && data.Success) {
              this.item = data.Result;

              if (this.item != null && this.item.Id > 0) {
                this.seleccionoFamiliaMaterial = (this.item.TipoMaterialId != null && this.item.TipoMaterialId > 0);

                this.getPedidoHistorial(this.pedidoId);
                this.getPedidoAprobaciones(this.pedidoId);
                this.loadAttachments(this.pedidoId);

                this.pedidoService.getPermisos(this.pedidoId).subscribe(data => {
                  this.isSearching = false;
                  if (data != null && data.Success) {
                    this.pedidoPermisos = data.Result;

                    this.formGroup.patchValue(this.item);

                    this.getPedidoItems(this.pedidoId);
                    this.getRemitosList();
                    this.getPedidoIncidencias(this.pedidoId);

                    this.getMoneda();

                    //Demoro su ejecucion para asegurar que la vista esta renderizada para las grillas agrupadas
                    setTimeout(() => {
                      this.getPresupuestosList();

                      this.getPedidoEntregas(this.pedidoId);
                      this.cambiosFormPedido();
                      this.cambiosFormHistorialPedido();
                    }, 500);
                  }

                },(err: HttpErrorResponse) => {
                  this.isSearching = false;
                  this.sharedFunctions.handleError(err, true);
                });
              }
              else {
                this.isSearching = false;
                this.msgError = "No se encontró el pedido seleccionado.";
              }
            }
            else {
              this.isSearching = false;
              this.msgError = "Ocurrió un error al intentar obtener los datos del pedido.";
            }
          },
          (err: HttpErrorResponse) => {
            this.isSearching = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
        else
          this.msgError = "Item no válido.";
      }
      else
      {
        this.pedidoService.getPermisos(0).subscribe(data =>{
          if(data != null && data.Success) {
            this.pedidoPermisos = data.Result;
          }
        },(err: HttpErrorResponse) => {
          this.isSearching = false;
          this.sharedFunctions.handleError(err, true);
        });

        this.item = new PedidoDto(0,null,null,null, null, null, null, null, null, null, null, null, [], [], [], true, false, []);
        this.formGroup.patchValue(this.item);
      }
    });
  }

  isProcessing() {
    return (this.isSearching || this.isSaving || this.isDeleting || this.isEnviandoPendienteEntrega || this.isSavingPedidoHistorial ||
      this.isAprobando || this.isRechazando || this.isEnviandoPresupuestar || this.isEnviandoRevision || this.isSavingPlan);
  }

  puedeVerAprobaciones() {
    return this.item != null && this.item.Id &&
    (this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_CREADO ||
     this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_REVISION);
  }

  puedeVerColumnaSeleccionPresupuesto(estadoId: number) {
    return this.pedidoPermisos?.CanSelectPresupuesto ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_COORDINACION ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_ENTREGA ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_ENTREGADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_RECHAZADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_FINALIZADO;
  }

  puedeVerFacturaPagada(estadoId: number) {
    return estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_COORDINACION ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_ENTREGA ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_ENTREGADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_RECHAZADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_FINALIZADO;
  }

  puedeVerEntregas(estadoId: number) {
    return estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_COORDINACION ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_ENTREGA ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_ENTREGADO;
  }

  puedeVerIncidencias(estadoId: number) {
    return estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_COORDINACION ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_ENTREGA ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_ENTREGADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_RECHAZADO ||
            estadoId == EstadoConstants.ESTADO_PEDIDO_FINALIZADO;
  }

//#endregion

// #region Form

  buildForm() {
    this.formGroup = this.formBuilder.group({
      'ComunidadOrigenId': [null, [Validators.required]],
      'ComunidadDestinoId': [null, [Validators.required]],
      'TipoMaterial': [null],
      'TipoMaterialId': [null, [Validators.required]],
      'Observacion': [""],
      'Activo': [true]
    });
  }

  buildFileForm() {
    this.formFileGroup = this.formBuilder.group({
      'Descripcion': [null, [Validators.required, Validators.maxLength(150)]]
    });
  }

  buildPedidoHistorialFormGroup() {
    this.pedidoHistorialFormGroup = this.formBuilder.group({
      'Descripcion': [null, [Validators.required, Validators.maxLength(150)]],
      'Observacion': [null, [Validators.maxLength(150)]]
    });
  }

  rowDataBound(args: RowDataBoundEventArgs) {
    let pedidoItemValue:any = args.data?.valueOf()
    if (pedidoItemValue.Observacion != null && pedidoItemValue.Observacion.length > 0) {
      args.row?.classList.add('has-observation');
    }
  }

//#endregion

// #region selects

  onSelectComunidadOrigen() {
    if (this.formGroup.value.ComunidadOrigenId != null && this.formGroup.value.ComunidadOrigenId > 0) {
      this.obraSeleccionada = true;
      this.formGroup.get('ComunidadDestinoId')?.setValue(this.formGroup.value.ComunidadOrigenId);
    }
    else
    this.obraSeleccionada = false;
  }

  onTipoMaterialSelect() {

      this.formGroup.get("TipoMaterialId")?.setValue(this.formGroup.get("TipoMaterial")?.value?.Id);
      this.seleccionoFamiliaMaterial = (this.formGroup.get("TipoMaterialId")?.value != null && this.formGroup.get("TipoMaterialId")?.value > 0) ||
                                        (this.item.TipoMaterialId != null && this.item.TipoMaterialId > 0);

      this.item.TipoMaterialId = this.formGroup.get("TipoMaterial")?.value?.Id;
      this.item.TipoMaterialNombre = this.formGroup.get("TipoMaterial")?.value?.Nombre;
  }

//#endregion

//#region Adjuntos

  onFileAttachedDelete(item: any) {
    this.cambioPendienteAdjuntos = true;
    if (item.Id > 0){
      this.onExistingFileAttachedDelete(item);
    }
    else{
      this.onNewFileAttachedDelete(item);
    }
  }

  onExistingFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.Id == item.Id);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttachedDelete(item: any) {
    if (this.item.Adjuntos != null && this.item.Adjuntos.length > 0) {
      var index = this.item.Adjuntos.findIndex(f => f.NombreDocumento == item.NombreDocumento);

      if (index >= 0)
        this.item.Adjuntos.splice(index, 1);
    }
  }

  onNewFileAttach(event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      this.cambioPendienteAdjuntos = true;
      var fileList = event.target.files;

      if (this.item.Adjuntos == null)
        this.item.Adjuntos = [];

      for (var i=0; i<fileList.length; i++) {
        if (this.item.Adjuntos.find(f => f.NombreDocumento == fileList[i].name)) {
          setTimeout(() => {
            this.sharedFunctions.showMessage("Ya existe un archivo con ese nombre. Por favor modifique el nombre del archivo o elimine el ya adjuntado", "Error");
          }, 100);
          return false;
        }
      }

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.pedidoService.uploadAttachTemp(fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            for (let i=0; i<data.Result.Archivos.length; i++) {
              if (data.Result.Archivos[i] != null) {
                data.Result.Archivos[i].Descripcion = this.newFileDescripcion;
                this.item.Adjuntos.push(data.Result.Archivos[i]);
                this.newFileDescripcion = "";
              }
            }
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

//#endregion

//#region Getters

  getComunidadesOrigen() {
    var loggedUser = this.sharedFunctions.getLoggedUser();
    var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, (loggedUser !== null ? loggedUser.PersonaId : null ), null, null, true);
    this.isComunidadOrigenSearching = true;

    this.comunidadService.search(r).subscribe(data => {
      this.isComunidadOrigenSearching = false;
      if (data != null) {
        this.comunidadOrigenList = data?.result;
        if(data.result.length == 1)
        {
          this.formGroup.controls['ComunidadOrigenId'].setValue(data.result[0].Id);
          this.onSelectComunidadOrigen();
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.isComunidadOrigenSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getComunidadesDestino() {
    this.isComunidadDestinoSearching = true;
    if (this.canHacerPrestamos) {
      var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, null, null, null, true);
      this.comunidadService.getAll(r).subscribe(data => {
        this.isComunidadDestinoSearching = false;
        this.comunidadDestinoList = data?.result;
      },
      (err: HttpErrorResponse) => {
        this.isComunidadDestinoSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
    else {
      var loggedUser = this.sharedFunctions.getLoggedUser();
      var r = new SearchComunidadRequest(null, null, true, "Nombre", null, null, (loggedUser !== null ? loggedUser.PersonaId : null), null, null, true);

      this.comunidadService.search(r).subscribe(data => {
        this.isComunidadDestinoSearching = false;
        this.comunidadDestinoList = data?.result;
      },
      (err: HttpErrorResponse) => {
        this.isComunidadDestinoSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  getPresupuestosList() {
    if (!(this.pedidoPermisos?.CanPresupuestoVer))
      return false;

    this.isPresupuestoSearching = true;
    this.pedidoService.getPresupuestoDetallesByPedidoId(this.pedidoId).subscribe(data => {
      this.isPresupuestoSearching = false;
      this.presupuestoList = data?.Result?.Presupuestos;
      this.presupuestoDetalleList = data?.Result?.PresupuestosDetalles;

      if (this.presupuestoDetalleList && this.presupuestoDetalleList.length == 1 )
        this.presupuestoDetalleList[0].Seleccionado = true;

      this.presupuestoGroupOptions = { columns: ['PedidoItemMaterial'] };

      if (this.puedeVerColumnaSeleccionPresupuesto(this.item?.EstadoId ?? 0)) {
        this.presupuestoChildGrid = {
          dataSource: this.presupuestoDetalleList,
          queryString: 'ProveedorId',
          load() {
            this.registeredTemplate = {};   // set registertemplate value as empty in load event
          },
          columns: [
            { field: 'PedidoItemMaterial', headerText: 'Pedido Item' },
            { field: 'MaterialNombre', headerText: 'Material Alternativo' },
            { field: 'Detalle', headerText: 'Detalle' },
            { field: 'Cantidad', headerText: 'Cantidad', format: "N2" },
            { field: 'MontoUnitario', headerText: 'Monto Unitario', format: "N2" },
            { field: 'Total', headerText: 'Total', format: "N2" },
            { headerText: 'Selección', template: this.presupuestoSeleccionChildTemplate }
          ]
        };

        if (this.presupuestoSeleccionChildTemplate?.elementRef?.nativeElement != null) {
          this.presupuestoSeleccionChildTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
          this.presupuestoSeleccionChildTemplate.elementRef.nativeElement.propName = 'template';
        }
      }
      else {
        this.presupuestoChildGrid = {
          dataSource: this.presupuestoDetalleList,
          queryString: 'ProveedorId',
          columns: [
            { field: 'PedidoItemMaterial', headerText: 'Pedido Item' },
            { field: 'MaterialNombre', headerText: 'Material Alternativo' },
            { field: 'Detalle', headerText: 'Detalle' },
            { field: 'Cantidad', headerText: 'Cantidad', format: "N2" },
            { field: 'MontoUnitario', headerText: 'Monto Unitario',  format: "N2" },
            { field: 'Total', headerText: 'Total',  format: "N2" },
          ]
        };
      }
    },
    (err: HttpErrorResponse) => {
      this.isPresupuestoSearching = false;
      this.presupuestosMsgError = err?.message;
      this.sharedFunctions.handleError(err);
    });
  }

  getRemitosList() {
    if (!(this.pedidoPermisos?.CanRemitoVer))
      return false;

    this.isRemitoSearching = true;
    this.pedidoService.getRemitoDetallesByPedidoId(this.pedidoId).subscribe(data => {
      this.isRemitoSearching = false;
      this.remitoList = data?.Result?.Remitos;
      this.remitoDetalleList = data?.Result?.RemitosDetalles;

      this.remitoChildGrid = {
        dataSource: this.remitoDetalleList,
        queryString: 'ProveedorId',
        load() {
          this.registeredTemplate = {};   // set registertemplate value as empty in load event
        },
        columns: [
          { field: 'FechaEntrega', headerText: 'Fecha Entrega', type:"date", format: "dd/MM/yyyy" },
          { field: 'Codigo', headerText: 'Cód. Remito' },
          { field: 'MaterialNombre', headerText: 'Material' },
          { field: 'Detalle', headerText: 'Detalle' },
          { field: 'Cantidad', headerText: 'Cantidad', textAlign: 'Right', format: "N2" },
          { field: 'MaterialUnidadMedidaNombre', headerText: 'Unid. Med.' },
          { headerText: 'Acción', template: this.remitoAccionChildTemplate }
        ]
      };

      if (this.remitoAccionChildTemplate?.elementRef?.nativeElement != null) {
        this.remitoAccionChildTemplate.elementRef.nativeElement._viewContainerRef = this.viewContainerRef;
        this.remitoAccionChildTemplate.elementRef.nativeElement.propName = 'template';
      }
    },
    (err: HttpErrorResponse) => {
      this.isRemitoSearching = false;
      this.remitosMsgError = err?.message;
      this.sharedFunctions.handleError(err);
    });
  }

  getPedidoHistorial(id: number) {
    this.isPedidoHistorialSearching = true;
    this.pedidoService.getPedidoHistorial(id).subscribe(data => {
      this.isPedidoHistorialSearching = false;
      this.pedidoHistorialDtoList = data?.Result;
    },
    (err: HttpErrorResponse) => {
      this.isPedidoHistorialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getPedidoAprobaciones(id: number) {
    if (!this.puedeVerAprobaciones())
      return false;

    if(this.item.PedidoComunidadRolAprobador) {
      this.aprobacionCoordinador = this.item.PedidoComunidadRolAprobador > PedidoComunidadRolConstants.COORDINADOR || this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_REVISION ? { } : null;
      this.aprobacionCoordinadorGeneral = this.item.PedidoComunidadRolAprobador > PedidoComunidadRolConstants.COORDINADOR_GENERAL || this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_REVISION ? { } : null;
      this.aprobacionCeo = this.item.PedidoComunidadRolAprobador == null || this.item.PedidoComunidadRolAprobador > PedidoComunidadRolConstants.CEO || this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_REVISION ? { } : null;
    }

    // this.isPedidoAprobacionesSearching = true;
    // this.pedidoService.getPedidoAprobaciones(id).subscribe(data => {
    //   this.isPedidoAprobacionesSearching = false;
    //   var pedidoAprobacionesList = data?.Result;
    //   if (pedidoAprobacionesList != null && pedidoAprobacionesList.length > 0) {
    //      if (pedidoAprobacionesList.some(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.COORDINADOR))
    //       this.aprobacionCoordinador = pedidoAprobacionesList.filter(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.COORDINADOR)[0];

    //     if (pedidoAprobacionesList.some(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.COORDINADOR_GENERAL))
    //       this.aprobacionCoordinadorGeneral = pedidoAprobacionesList.filter(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.COORDINADOR_GENERAL)[0];

    //     if (pedidoAprobacionesList.some(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.CEO)) {
    //       this.aprobacionCeo = pedidoAprobacionesList
    //                             .filter(f => f.PedidoComunidadRolId == PedidoComunidadRolConstants.CEO)
    //                             .sort((a: PedidoHistorialDto, b: PedidoHistorialDto) => {
    //                               return (a.FechaCreacion > b.FechaCreacion ? -1 : 1);
    //                             })[0];
    //     }
    //   }
    // },
    // (err: HttpErrorResponse) => {
    //   this.isPedidoAprobacionesSearching = false;
    //   this.sharedFunctions.handleError(err);
    // });
  }

  getAprobadorText(aprobador: any, defaultText: string) {
    return aprobador != null ? ((aprobador.UsuarioNombre ?? "") + ' (' + this.datePipe.transform(aprobador.FechaCreacion, 'dd/MM') + ')') : defaultText;
  }

  getPedidoEntregas(id: number) {
    if (!this.puedeVerEntregas(this.item?.EstadoId ?? 0))
      return false;

    this.isPedidoEntregasSearching = true;
    this.pedidoService.getPedidoEntregas(id).subscribe(data => {
      this.isPedidoEntregasSearching = false;
      this.pedidoEntregasDto = data?.Result;

      this.entregasPorProveedorChildGrid = {
        dataSource: this.pedidoEntregasDto.Materiales,
        queryString: 'ProveedorNombre',
        load() {
          this.registeredTemplate = {};   // set registertemplate value as empty in load event
        },
        columns: [
          { field: 'MaterialNombre', headerText: 'Material' },
          { field: 'Detalle', headerText: 'Detalle' },
          { field: 'CantidadPedida', headerText: 'Solicitado', textAlign: 'Right', format: "N2" },
          { field: 'CantidadEntregada', headerText: 'Entregado', textAlign: 'Right', format: "N2" },
          { field: 'Diferencia', headerText: 'Pendiente', textAlign: 'Right', format: "N2" }
        ]
      };

      this.entregasPorMaterialChildGrid = {
        dataSource: this.pedidoEntregasDto?.Materiales,
        queryString: 'MaterialNombre',
        load() {
          this.registeredTemplate = {};   // set registertemplate value as empty in load event
        },
        columns: [
          { field: 'ProveedorNombre', headerText: 'Proveedor' },
          { field: 'Detalle', headerText: 'Detalle' },
          { field: 'CantidadPedida', headerText: 'Solicitado', textAlign: 'Right', format: "N2" },
          { field: 'CantidadEntregada', headerText: 'Entregado', textAlign: 'Right', format: "N2" },
          { field: 'Diferencia', headerText: 'Pendiente', textAlign: 'Right', format: "N2" }
        ]
      };
    },
    (err: HttpErrorResponse) => {
      this.isPedidoEntregasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getPedidoIncidencias(id: number) {
    var r = new SearchIncidenciaUsuarioRequestDto(null, null, true, "FechaUltimoMensaje", null, null, null, null, null, null, null, null, id, null, null, null, null, null, null, null);
    this.isPedidoIncidenciasSearching = true;

    this.incidenciaUsuarioService.search(r).subscribe(data => {
      this.isPedidoIncidenciasSearching = false;
      this.pedidoIncidenciasList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isPedidoIncidenciasSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  loadAttachments(id: number) {
    this.isAttachmentSearching = true;
    this.pedidoService.getAttachments(id).subscribe(data => {
      this.isAttachmentSearching = false;
      this.item.Adjuntos = data.Result;
    },
    (err: HttpErrorResponse) => {
      this.isAttachmentSearching = false;
      this.sharedFunctions.handleError(err);
    })
  }

  getPedidoItems(id: number) {
    this.isPedidoItemsSearching = true;
    this.pedidoService.getPedidoItems(id).subscribe(data => {
      this.isPedidoItemsSearching = false;
      if (this.item != null) {
        this.item.PedidoItems = data?.Result;

        if (this.item.PedidoItems != null && (this.pedidoPermisos?.CanPlanificar || this.pedidoPermisos?.CanPlanificarEditar)) {
          this.itemPlanificacionList = [];
          for (var i=0; i<this.item.PedidoItems.length; i++) {
            this.itemPlanificacionList.push(new SavePedidoPlanificacionItemDto(
              this.item.PedidoItems[i].Id,
              this.item.PedidoItems[i].MaterialNombre,
              this.item.PedidoItems[i].Detalle,
              this.item.PedidoItems[i].Cantidad,
              this.item.PedidoItems[i].MaterialUnidadMedida,
              this.item.PedidoItems[i].FechaEntregaPlanificada?.toString(),
              this.item.PedidoItems[i].ProveedorId,
              this.item.PedidoItems[i].ProveedorNombre,
              this.item.PedidoItems[i].MonedaId,
              this.item.PedidoItems[i].MonedaNombre,
              this.item.PedidoItems[i].Monto,
              new FormControl(),
              false,
              []
            ));

            this.itemPlanificacionList[i].ProveedorPlanificacionFormControl?.setValue(
              new Proveedor(
                this.item.PedidoItems[i].ProveedorId,
                null,
                this.item.PedidoItems[i].ProveedorNombre,
                null, null, null, null, null, null, null, null, null, true, null, null, null, null, []
              )
            );

            this.getProveedoresPlanificacionAutocomplete(i);
          }
        }
      }
    },
    (err: HttpErrorResponse) => {
      this.isPedidoItemsSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getTipoMaterial() {
    var r = new SearchTipoMaterialRequest(null, null, true, "Nombre", null, null, true);
    this.isTipoMaterialSearching = true;

    this.tipoMaterialService.search(r).subscribe(data => {
      this.tipoMaterialList = data?.result;
      this.isTipoMaterialSearching = false;
    },
    (err: HttpErrorResponse) => {
      this.isTipoMaterialSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  getMoneda() {
    if (this.pedidoPermisos?.CanPlanificar) {
      this.isMonedaSearching = true;
      this.monedaService.search(new SearchMonedaRequest(null,null,true,"Codigo",null,null,null,true)).subscribe(data=> {
        this.isMonedaSearching = false;
        this.monedaList = data?.result;
      },
      (err: HttpErrorResponse)=> {
        this.isMonedaSearching = false;
        this.sharedFunctions.handleError(err);
      });
    }
  }

  getProveedoresPlanificacionAutocomplete(index: number) {
    this.itemPlanificacionList[index].ProveedorPlanificacionFormControl?.valueChanges
      .pipe(
        filter(res => {
          return res && res !== null && res.length >= 3
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {
          this.itemPlanificacionList[index].FilteredProveedorPlanificacionList = [];
          this.itemPlanificacionList[index].IsProveedorPlanificacionAutoSearching = true;
        }),
        switchMap(value => this.proveedorService.search(new SearchProveedorRequest(null, null, true, "RazonSocial", null, !isNumber(parseInt(value)) ? value : null, isNumber(parseInt(value)) ? value : null, null, null, null, true))
          .pipe(
            finalize(() => {
              this.itemPlanificacionList[index].IsProveedorPlanificacionAutoSearching = false;
            }),
          )
        )
      )
      .subscribe((data: any) => {
        if (data != null && data.result != null)
          this.itemPlanificacionList[index].FilteredProveedorPlanificacionList = data.result;
        else
          this.itemPlanificacionList[index].FilteredProveedorPlanificacionList = [];
      });
  }

  displayProveedor(proveedor: Proveedor): string {
    return proveedor && proveedor?.RazonSocial ? proveedor.RazonSocial : '';
  }

  getItemPlanificacionIndex(id: number) {
    return this.itemPlanificacionList?.findIndex(x => x.Id == id);
  }

//#endregion

//#region Modals

  onHistorialDetalleCambioClick(item: any) {
    if (item == null || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para continuar", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '600px',
      data: new DialogConfirmRequest(
        "Detalle de Cambios",
        item.DetalleCambios,
        "Aceptar", null,
        true, false
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
    });
  }

  agregarComparativa() {
    const dialogRef = this.dialog.open(DialogAgregarComparativaComponent, {
      width: '900px',
      data: new DialogAgregarComparativa
      (
        this.pedidoId,
        this.item.PedidoItems,
        this.item.TipoMaterialId ?? 0,
        this.pedidoPermisos.CanAddPresupuesto,
        this.pedidoPermisos.CanSelectPresupuesto
      )
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result != null && result.length > 0) {
        this.cambioPendientePresupuesto = true;
        this.getPresupuestosList();
      }
    });
  }

  editPresupuesto(itemId: number) {
    const dialogRef = this.dialog.open(DialogAgregarPresupuestoComponent, {
      width: '900px',
      data: new DialogAgregarPresupuesto
      (
        (itemId ?? 0),
        this.pedidoId,
        this.item.PedidoItems,
        this.item.TipoMaterialId ?? 0,
        (itemId != null && itemId > 0 ? this.pedidoPermisos.CanEditPresupuesto : this.pedidoPermisos.CanAddPresupuesto),
        this.pedidoPermisos.CanSelectPresupuesto,
        null
      )
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result != null && result.Id > 0) {
        this.cambioPendientePresupuesto = true;
        this.getPresupuestosList();
      }
    });
  }

  deletePresupuesto(itemId: number) {
    if (itemId > 0) {
      if (!this.pedidoPermisos?.CanDeletePresupuesto)
        return false;

      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        width: '600px',
        data: new DialogConfirmRequest(
          "Borrado de Presupuesto",
          "¿Está seguro que desea eliminar el presupuesto?",
          null, null
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          this.cambioPendientePresupuesto = true;
          this.pedidoService.deletePresupuesto(this.pedidoId, itemId).subscribe(data => {
            if (data != null && data.Success && data.Result) {
              this.getPresupuestosList();
            }
            else
              this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.sharedFunctions.handleError(err, true);
          })
        }
      });
    }
  }

  addMaterialItem() {
    var addPedidoItem = new ModalPedidoItemDto
    (
      0,
      this.pedidoId,
      null,
      this.pedidoPermisos.CanEdit,
      this.item.TipoMaterialId,
      this.item.TipoMaterialNombre
    );

    const dialogRef = this.dialog.open(DialogModificarPedidoItemComponent, {
      width: '70vw',
      data: addPedidoItem
    });

    dialogRef.afterClosed().subscribe((result: PedidoItemDto) => {
      if (result != null) {

        this.cambioPendienteMaterial = !(this.item.Id > 0);

        if (this.item.PedidoItems == null)
          this.item.PedidoItems = [];

        this.item.PedidoItems.push(result);
        this.pedidoItemGrid.refresh();

        if (this.pedidoItemPlanificacionGrid != null)
          this.pedidoItemPlanificacionGrid.refresh();
      }
    });
  }


  editMaterialItem(item: any) {
    const dialogRef = this.dialog.open(DialogModificarPedidoItemComponent, {
      width: '70vw',
      data: new ModalPedidoItemDto
      (
        item?.Id ?? 0,
        this.pedidoId,
        item,
        (item != null && item.Id > 0 ? this.pedidoPermisos.CanEditMaterial : this.pedidoPermisos.CanAddMaterial),
        this.item.TipoMaterialId,
        this.item.TipoMaterialNombre,
        this.item.EstadoId ?? 0,
        this.item.ComunidadOrigenId ?? 0,
        this.item.ComunidadDestinoId ?? 0,
        this.item.Observacion,
        this.item.Pagado
      )
    });

    dialogRef.afterClosed().subscribe((result: PedidoItemDto) => {
      if (result != null) {
        this.cambioPendienteMaterial = false;
        if (this.item != null && this.item.Id > 0) {
          this.getPedidoItems(this.item.Id);
        }
        else {
          this.cambioPendienteMaterial = true;
          var index = item.index + (((this.pedidoItemGrid.pageSettings.currentPage ?? 0) - 1) * (this.pedidoItemGrid.pageSettings.pageSize ?? 0));
          this.item.PedidoItems[index] = result;

          this.pedidoItemGrid.refresh();
        }

        if (this.pedidoItemPlanificacionGrid != null)
          this.pedidoItemPlanificacionGrid.refresh();
      }
    });
  }

  editMaterialesFechasMasivo() {
    const dialogRef = this.dialog.open(DialogFechaMasivaMaterialComponent, {
      width: '50vw',
      data: new ModalPedidoItemsDto(
        this.item,
        this.pedidoPermisos?.CanEditMaterial ? true : false
      ),
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.cambioPendienteMaterial = false;

        if (result.Id != null) {
          this.item = result;
          this.onGuardarMaterial()
        }
        else {
          this.sharedFunctions.showMessage("Ocurrio un error al querer actualizar fechas de materiales " + result, "Error");
        }
      }
    });
  }

  editMaterialPlanificacionItem(item: any) {
    var index = this.item.PedidoItems.findIndex(f => f.Id == item.Id);
    if (index >= 0)
      this.editMaterialItem(this.item.PedidoItems[index]);
    else {
      this.pedidoItemPlanificacionGrid.refresh();
      this.sharedFunctions.showMessage("No se encontró el item seleccionado", "Error");
    }
  }

  deleteMaterialItem(p: any) {
    if (p != null) {

      if (!this.pedidoPermisos?.CanDeleteMaterial)
        return false;

      if (this.item.Id > 0) {
        const dialogRef = this.dialog.open(DialogConfirmComponent, {
          width: '600px',
          data: new DialogConfirmRequest(
            "Borrado de Material",
            "¿Está seguro que desea eliminar el material?",
            "Sí", "No"
          )
        });

        dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
          if (result != null && result.Accepted) {
            this.cambioPendienteMaterial = false;
            this.pedidoService.deletePedidoItem(p.Id).subscribe(data => {
              if (data != null && data.Success && data.Result) {
                this.removePedidoItem(p);
              }
              else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
            },
            (err: HttpErrorResponse) => {
              this.sharedFunctions.handleError(err, true);
            })
          }
        });
      }
      else {
        this.cambioPendienteMaterial = true;
        this.removePedidoItem(p);
      }
    }
  }

  removePedidoItem(p: any) {
    var index = -1;
    if (p.Id != null && p.Id > 0)
      index = this.item.PedidoItems?.findIndex(f => f.Id == p.Id);
    else
      index = this.item.PedidoItems?.findIndex(f => f.MaterialId == p.MaterialId && f.Cantidad == p.Cantidad);

    if (index > -1) {
      this.cambioPendienteMaterial = !(this.item.Id > 0);
      this.item.PedidoItems.splice(index, 1);
      this.pedidoItemGrid.refresh();

      if (this.pedidoItemPlanificacionGrid != null)
        this.pedidoItemPlanificacionGrid.refresh();
    }
  }

  editRemito(itemId: number) {
    const dialogRef = this.dialog.open(DialogVerRemitoComponent, {
      width: '900px',
      data: itemId
    });

    dialogRef.afterClosed().subscribe((result: any) => {

    });
  }

  onRemitoNewFileAttach(pedidoRemitoId: number, event: any) {
    if (event?.target?.files != null && event.target.files.length > 0) {
      var fileList = event.target.files;

      if (fileList != null && fileList.length > 0) {
        this.isFileAttaching = true;
        this.pedidoService.uploadRemitoAttach(pedidoRemitoId, fileList).subscribe(data => {
          this.isFileAttaching = false;
          if (data != null && data.Success && data.Result != null && data.Result.Archivos != null && data.Result.Archivos.length > 0) {
            this.sharedFunctions.showMessage("Remito adjuntado éxitosamente!", "Operación éxitosa!");
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error intentando subir los archivos", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isFileAttaching = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    }
  }

  puedeAsociarPresupuestoAlPedidoItem(item?: any) {
    //asociar desde el item
    if(item != null) {
      return item.Id > 0 &&  (this.presupuestoDetalleList == null || !this.presupuestoDetalleList.some(f => f.PedidoItemId == item.Id));
    }
    // asociar desde cambios masivos presupuesto
    if(!item) {
      if(this.presupuestoDetalleList == null) return true;
      const idsItemConPresupuesto = this.presupuestoDetalleList.map(detalle => detalle.PedidoItemId);
      const result = this.item.PedidoItems.some(item => !idsItemConPresupuesto.includes(item.Id))
      return result
    }
  }

  addPlanificacionMaterialItem(item: any) {
    if (item == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item para agregar el presupuesto", "Error");
      return false;
    }

    var index = this.item.PedidoItems.findIndex(f => f.Id == item.Id);
    if (index < 0) {
      this.pedidoItemPlanificacionGrid.refresh();
      this.sharedFunctions.showMessage("No se encontró el item seleccionado", "Error");
      return false;
    }

    const dialogRef = this.dialog.open(DialogAgregarPresupuestoComponent, {
      width: '900px',
      data: new DialogAgregarPresupuesto
      (
        0,
        this.pedidoId,
        this.item.PedidoItems,
        this.item.TipoMaterialId ?? 0,
        this.pedidoPermisos.CanAddPresupuesto,
        this.pedidoPermisos.CanSelectPresupuesto,
        this.item.PedidoItems[index].Id
      )
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result != null && result.Id > 0) {
        this.getPedidoItems(this.item?.Id);
        this.getPresupuestosList();
      }
    });
  }

  addPlanificacionMaterialItemMasiva() {
    let dialogRef: MatDialogRef<any>;

    if(this.presupuestoDetalleList != null && this.presupuestoDetalleList.length > 0) {
      const idsItemConPresupuesto = this.presupuestoDetalleList.map(detalle => detalle.PedidoItemId);
      this.item.PedidoItems = this.item.PedidoItems.filter(item => !idsItemConPresupuesto.includes(item.Id))
    }
            // Llamada masiva
            dialogRef = this.dialog.open(DialogAgregarPresupuestoComponent, {
                width: '900px',
                data: new DialogAgregarPresupuesto(
                    0,
                    this.pedidoId,
                    this.item.PedidoItems,
                    this.item.TipoMaterialId,
                    this.pedidoPermisos.CanAddPresupuesto,
                    this.pedidoPermisos.CanSelectPresupuesto,
                    0
                ),
            });

        // Manejo del resultado
        dialogRef.afterClosed().subscribe((result: any) => {
            if (result != null && result.Id > 0) {
                this.getPedidoItems(this.item?.Id);
                this.getPresupuestosList();
            }
        });
  }


//#endregion

//#region actions

  onSelectPresupuestoDetalle(item: any, event: any) {
    var index = this.presupuestoDetalleList.map(s => s.Id).indexOf(item.Id);
    this.cambioPendientePresupuesto = true;
    if (index >= 0)
      this.presupuestoDetalleList[index].Seleccionado = event.checked;
  }

  onPedidoItemPlanificacionChange(rowId: number, event: any) {
    if (rowId > 0 && this.itemPlanificacionList != null) {
      this.cambioPendientePlanificacion = true;
      var index = this.getItemPlanificacionIndex(rowId);

      if (index >= 0) {
        var controlName = event?.target?.name ?? event?.targetElement?.name ?? event?.source?.ngControl?.name;
        var controlValue = event?.value ?? event?.target?.value ?? event?.option?.value;

        if (controlName == null || controlName.length <= 0)
          controlName = ((event.source as MatAutocomplete) != null) ? "ProveedorPlanificacion" : null;

        // console.log(controlName,controlValue);
        switch (controlName) {
          case "ProveedorPlanificacion":
            this.itemPlanificacionList[index].ProveedorId = controlValue?.Id;
            this.itemPlanificacionList[index].ProveedorNombre = controlValue?.RazonSocial;
            break;
          case "MonedaId":
            this.itemPlanificacionList[index].MonedaId = controlValue;
            break;
          case "Monto":
            this.itemPlanificacionList[index].Monto = controlValue;
            break;
          case "FechaEntregaPlanificada":
            this.itemPlanificacionList[index].FechaEntregaPlanificada = controlValue;
            break;
        }
      }
    }
  }

  onGuardar() {
    if (this.item != null && this.item.Id > 0)
      this.guardarPedido();
    else
      this.crearPedido();
  }

  crearPedido() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
    }
    if (this.item.Adjuntos == null)
      this.item.Adjuntos = [];

    var r = new PedidoDto(0, null, null, null, null, null, null, null, null, null, null, null, [], [], [], true, false, []);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Pagado: (this.item?.Pagado ?? false),
        Activo: this.item.Activo,
        PedidoItems: this.item.PedidoItems,
        Adjuntos: this.item?.Adjuntos
      }
    };

    this.isSaving = true;
    this.pedidoService.save(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        if (r.Id != null && r.Id > 0) {
          this.cambioPendientePedido = false;
          this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
          this.sharedFunctions.reloadCurrentRoute();
        }
        else {
          this.resetCambiosPendientes();
          this.sharedFunctions.showMessage("Se generó correctamente el pedido #" + data.Result.Id, "Operación Exitosa!");
          this.onCancel();
        }
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  guardarPedido() {
    if (!this.formGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new PedidoDto(0, null, null, null, null, null, null, null, null, null, null, null,[], [], [], true, false, []);

    r =
    {
      ...this.formGroup.value,
      ...
      {
        Id: (this.item?.Id ?? 0),
        Pagado: (this.item?.Pagado ?? false),
        Activo: this.item.Activo
      }
    };

    this.isSaving = true;
    this.pedidoService.savePedidoCabecera(r).subscribe(data => {
      this.isSaving = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.cambioPendientePedido = false;
        if (r.Id != null && r.Id > 0) {
          this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
          this.sharedFunctions.reloadCurrentRoute();
        }
        else {
          this.resetCambiosPendientes();
          this.sharedFunctions.showMessage("Se generó correctamente el pedido #" + data.Result.Id, "Operación Exitosa!");
          this.onCancel();
        }
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSaving = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGuardarMaterial() {
    this.isSavingMaterial = true;
    this.pedidoService.savePedidoItems(this.item).subscribe(data => {
      this.isSavingMaterial = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.cambioPendienteMaterial = false;
        this.getPedidoItems(this.pedidoId);
        this.getPedidoEntregas(this.pedidoId);
        this.getPedidoHistorial(this.pedidoId);
        this.sharedFunctions.showMessage("Se guardaron correctamente los materiales!", "Operación Exitosa!");
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingMaterial = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGuardarAdjunto() {
    this.isSavingAdjunto = true;
    this.pedidoService.savePedidoAdjuntos(this.item).subscribe(data => {
      this.isSavingAdjunto = false;
      if (data != null && data.Success && data.Result != null && data.Result.Id > 0) {
        this.cambioPendienteAdjuntos = false;
        this.sharedFunctions.showMessage("Se guardaron correctamente los adjuntos!", "Operación Exitosa!");
        // this.onCancel();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingAdjunto = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGuardarPedidoHistorial() {
    if (!this.pedidoPermisos?.CanComentar) {
      return false;
    }

    if (!this.pedidoHistorialFormGroup.valid) {
      this.sharedFunctions.showMessage("Por favor complete todos los datos obligatorios para continuar", "Error");
      return false;
    }

    var r = new SavePedidoHistorialDto(0, null, null,'');

    r =
    {
      ...this.pedidoHistorialFormGroup.value,
      ...
      {
        PedidoId: (this.item?.Id ?? 0)
      }
    };

    this.isSavingPedidoHistorial = true;
    this.pedidoService.saveHistorial(r).subscribe(data => {
      this.isSavingPedidoHistorial = false;
      if (data != null && data.Success) {
        this.pedidoHistorialFormGroup.reset();
        this.cambioPendienteHistorialPedido = false;
        this.getPedidoHistorial(this.item.Id);
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingPedidoHistorial = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGuardarPresupuestoDetalleSeleccion() {

    if (this.presupuestoDetalleList == null || this.presupuestoDetalleList.length == 0) {
      this.sharedFunctions.showMessage("No hay detalles de presupuestos disponibles en este pedido", "Error");
      return false;
    }

    if (!this.presupuestoDetalleList.some(f => f.Seleccionado == true)) {
      const dialogRef = this.dialog.open(DialogConfirmComponent, {
        width: '600px',
        data: new DialogConfirmRequest(
          "Selección de Presupuesto",
          "No tiene seleccionado ningún detalle de presupuesto. Si previamente tenía seleccionados presupuestos, quedarán sin seleccionar.<br/><br/>¿Está seguro que desea continuar con la operación?",
          null, null
        )
      });

      dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted)
          this.doSavePresupuestoSeleccion(this.presupuestoDetalleList);
      });
    }
    else
      this.doSavePresupuestoSeleccion(this.presupuestoDetalleList);
  }

  doSavePresupuestoSeleccion(presupuestoList: any[]) {
    var r = new SavePedidoPresupuestoSeleccion
    (
      this.pedidoId,
      null,
      presupuestoList?.filter(f => f.Seleccionado == true)?.map(s => s.Id)
    );

    this.isSavingPresupuestoSeleccion = true;
    this.pedidoService.savePresupuestoSeleccion(r).subscribe(data => {
      this.cambioPendientePresupuesto = false;
      this.isSavingPresupuestoSeleccion = false;
      if (data != null && data.Success) {
        this.cambioPendientePlanificacion = false;
        this.sharedFunctions.showMessage("Se seleccionaron correctamente los presupuestos!", "Operación Exitosa!");
        this.getPresupuestosList();

        this.gridPresupuestos.refresh();
        this.gridPresupuestosDetalle.refresh();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingPresupuestoSeleccion = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onAprobar() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {

        if (result != null && result.Accepted) {
          var mostrarAlertaConfirmarSinPresupuestos = false;

          if (this.pedidoPermisos?.CanPresupuestoVer) {
            if (this.item.EstadoId == EstadoConstants.ESTADO_PEDIDO_PENDIENTE_REVISION) {
              mostrarAlertaConfirmarSinPresupuestos = (this.presupuestoList == null || this.presupuestoList.length == 0);
            }
          }

          var msg = "¿Está seguro que desea aprobar el pedido?";
          if (mostrarAlertaConfirmarSinPresupuestos)
            msg += "<br/><br/><b>El pedido no tiene asociado ningún presupuesto, pero se le podrá agregar uno en la siguiente transición.</b>";

          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            width: '600px',
            data: new DialogConfirmRequest(
              "Aprobación de Pedido",
              msg,
              null, null
            )

          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted) {
              var r = new AprobarPedidoDto((this.item?.Id ?? 0), false, "");
              this.isAprobando = true;
              this.pedidoService.aprobar(r).subscribe(data => {
                this.isAprobando = false;
                if (data != null && data.Success && data.Result == true) {
                  this.sharedFunctions.showMessage("Se aprobó correctamente el pedido!", "Operación Exitosa!");
                  this.sharedFunctions.reloadCurrentRoute();
                }
                else
                  this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
              },
              (err: HttpErrorResponse) => {
                this.isAprobando = false;
                this.sharedFunctions.handleError(err, true);
              })
            }
          });
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  onRechazar() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          const dialogRef = this.dialog.open(DialogConfirmComponent, {
            width: '600px',
            data: new DialogConfirmRequest(
              "Rechazo de Pedido",
              "¿Está seguro que desea rechazar el pedido?",
              null, null
            )
          });

          dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
            if (result != null && result.Accepted) {
              var r = new AprobarPedidoDto((this.item?.Id ?? 0), true, '');
              this.isRechazando = true;
              this.pedidoService.rechazar(r).subscribe(data => {
                this.isRechazando = false;
                if (data != null && data.Success && data.Result == true) {
                  this.sharedFunctions.showMessage("Se rechazó correctamente el pedido", "Operación Exitosa!");
                  this.sharedFunctions.reloadCurrentRoute();
                }
                else
                  this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
              },
              (err: HttpErrorResponse) => {
                this.isRechazando = false;
                this.sharedFunctions.handleError(err, true);
              })
            }
          });
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  onDarBaja(){
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '600px',
      data: new DialogConfirmRequest(
        "Rechazo de Pedido",
        "¿Está seguro que desea dar de baja el pedido?<br/><br/><b>Una vez dado de baja el pedido, no se podrá ejecutar ninguna otra acción.</b>",
        null, null
      )
    });

    dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
      if (result != null && result.Accepted) {
        this.isDeleting = true;
        this.pedidoService.deletePedido(this.item?.Id).subscribe(data => {
          this.isDeleting = false;
          if (data != null && data.Success && data.Result == true) {
            this.sharedFunctions.showMessage("Se dió de baja el pedido correctamente", "Operación Exitosa!");
            this.onCancel();
          }
          else
            this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
        },
        (err: HttpErrorResponse) => {
          this.isDeleting = false;
          this.sharedFunctions.handleError(err, true);
        })
      }
    });
  }

  onGuardarPlanificacionMasiva() {
    const dialogRef = this.dialog.open(DialogFechaMasivaMaterialComponent, {
      width: '500px',
      data: {
        PedidoDto: this.item,
        CanEditMaterial: this.pedidoPermisos?.CanPlanificar,
        Mode: 'FECHA_PLANIF',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.PedidoItems) {
        this.itemPlanificacionList = this.itemPlanificacionList.map(planItem => {
          const updatedItem = result.PedidoItems.find(item => item.Id === planItem.Id);
          if (updatedItem) {
            return {
              ...planItem,
              FechaEntregaPlanificada: updatedItem.FechaEntregaPlanificada
            };
          }
          return planItem;
        });

        this.onGuardarPlanificacion();
      }
    });
  }

  enviarPresupuestar() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
          this.isEnviandoPresupuestar = true;
            this.pedidoService.postEnviarPresupuestarPedido(r.PedidoId).subscribe(data => {
              this.isEnviandoPresupuestar = false;
              if (data != null && data.Success && data.Result != null) {
                this.sharedFunctions.showMessage("Se envió a presupuestar correctamente el pedido!", "Operación Exitosa!");
                this.sharedFunctions.reloadCurrentRoute();
              }
              else
                this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEnviandoPresupuestar = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  enviarRevision() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
          this.isEnviandoRevision = true;

          this.pedidoService.postEnviarRevisionPedido(r.PedidoId).subscribe(data => {
            this.isEnviandoRevision = false;
            if (data != null && data.Success && data.Result != null) {
              this.sharedFunctions.showMessage("Se envió a revisión correctamente el pedido!", "Operación Exitosa!");
              this.sharedFunctions.reloadCurrentRoute();
            }
            else
              this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEnviandoRevision = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  enviarPendienteEntrega() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
          this.isEnviandoPendienteEntrega = true;

          this.pedidoService.postEnviarPendienteEntrega(r.PedidoId).subscribe(data => {
            this.isEnviandoPendienteEntrega = false;
            if (data != null && data.Success && data.Result != null) {
              this.sharedFunctions.showMessage("Se envió a pendiente de entrega correctamente el pedido!", "Operación Exitosa!");
              this.sharedFunctions.reloadCurrentRoute();
            }
            else
              this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEnviandoPendienteEntrega = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  enviarPendienteCoordinacion() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
          this.isEnviandoPendienteCoordinacion = true;

          this.pedidoService.postEnviarPendienteCoordinacion(r.PedidoId).subscribe(data => {
            this.isEnviandoPendienteCoordinacion = false;
            if (data != null && data.Success && data.Result != null) {
              this.sharedFunctions.showMessage("Se envió a pendiente de coordinación correctamente el pedido!", "Operación Exitosa!");
              this.sharedFunctions.reloadCurrentRoute();
            }
            else
              this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
          },
          (err: HttpErrorResponse) => {
            this.isEnviandoPendienteCoordinacion = false;
            this.sharedFunctions.handleError(err, true);
          })
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  enviarEntregado() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          if (this.pedidoEntregasDto != null && this.pedidoEntregasDto.HayPendientesEntrega) {
            var msg = "El pedido todavía tiene materiales con entregas pendientes. ¿Está seguro que desea marcar al mismo como entregado?" +
              "<br/><br/><b>Se ajustarán las cantidades de los materiales que no fueron entregados.</b>";

            const dialogRef = this.dialog.open(DialogConfirmComponent, {
              width: '600px',
              data: new DialogConfirmRequest(
                "Pedido con entregas pendientes",
                msg,
                "Sí, mover a Entregado de todas formas",
                "No, dejar el pedido como está ahora"
              )
            });

            dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
              if (result != null && result.Accepted) {
                this.doEnviarEntregado();
              }
            });
          }
          else
            this.doEnviarEntregado();
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  doEnviarEntregado() {
    var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
    this.isEnviandoEntregado = true;

    this.pedidoService.postEnviarEntregado(r.PedidoId).subscribe(data => {
      this.isEnviandoEntregado = false;
      if (data != null && data.Success && data.Result != null) {
        this.sharedFunctions.showMessage("Se entregó correctamente el pedido!", "Operación Exitosa!");
        this.sharedFunctions.reloadCurrentRoute();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isEnviandoEntregado = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  enviarFinalizado() {
    this.pedirConfirmacionDescarteCambios()
      .then((result: DialogConfirmResponse) => {
        if (result != null && result.Accepted) {
          var msg = "¿Está seguro que desea finalizar el pedido?";
          if (this.item != null && this.item.Pagado) {
            const dialogRef = this.dialog.open(DialogConfirmComponent, {
              width: '600px',
              data: new DialogConfirmRequest(
                "Finalizar el pedido",
                msg,
                null, null
              )
            });
            dialogRef.afterClosed().subscribe((result: DialogConfirmResponse) => {
              if (result != null && result.Accepted) {
                this.doEnviarFinalizado();
              }
            });
          }
          else
            this.sharedFunctions.showMessage("El pedido debe estar pagado antes de poder finalizarlo", "Error");
        }
      })
      .catch((error) => {
        console.error('Error al obtener confirmación:', error);
      });
  }

  doEnviarFinalizado() {
    var r = new PedidoEstadoChangeDto((this.item?.Id ?? 0));
    this.isEnviandoEntregado = true;

    this.pedidoService.postEnviarFinalizado(r.PedidoId).subscribe(data => {
      this.isEnviandoEntregado = false;
      if (data != null && data.Success && data.Result != null) {
        this.sharedFunctions.showMessage("Se finalizó correctamente el pedido!", "Operación Exitosa!");
        this.sharedFunctions.reloadCurrentRoute();
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isEnviandoEntregado = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onCancel() {
    // this.router.navigate(['/pedido-list']);
    this.location.back();
  }

  onGuardarPlanificacion() {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const fechaInvalida = this.itemPlanificacionList.some(item => {
      const fechaPlanificada = new Date(item.FechaEntregaPlanificada);
      fechaPlanificada.setHours(0, 0, 0, 0);
      return fechaPlanificada < today;
    });

    if (fechaInvalida) {
      this.sharedFunctions.showMessage("La fecha de planificación no puede ser menor a la fecha actual", "Error");
      return;
    }

    var r = new SavePedidoPlanificacionDto(
      this.item.Id,
      this.itemPlanificacionList?.map(s => new SavePedidoPlanificacionItemDto(
        s.Id, s.MaterialNombre, s.Detalle, s.Cantidad, s.MaterialUnidadMedida, s.FechaEntregaPlanificada,
        s.ProveedorId, s.ProveedorNombre, s.MonedaId, s.MonedaNombre, s.Monto, null, false, []))
    );

    this.isSavingPlan = true;
    this.pedidoService.savePedidoPlanificacion(r).subscribe(data => {
      this.cambioPendientePlanificacion = false;
      this.isSavingPlan = false;
      if (data != null && data.Success) {
        this.getPedidoHistorial(this.item?.Id);
        this.sharedFunctions.showMessage("Se guardaron correctamente los datos!", "Operación Exitosa!");
      }
      else
        this.sharedFunctions.showMessage(data?.Message ?? "Ocurrió un error ejecutando la operación", "Error");
    },
    (err: HttpErrorResponse) => {
      this.isSavingPlan = false;
      this.sharedFunctions.handleError(err, true);
    })
  }

  onGenerarIncidenciaFaltante(proveedorId: number) {
    if (this.pedidoPermisos?.ShowBotonCrearIncidente) {
      var navExtras = { pedidoId: this.pedidoId, proveedorId: proveedorId, faltante: 1 };
      this.router.navigate(['incidencia-usuario-edit/0', navExtras]);
    }
  }

  onGenerarIncidencia() {
    if (this.pedidoPermisos?.ShowBotonCrearIncidente) {
      var navExtras = { pedidoId: this.pedidoId };
      this.router.navigate(['incidencia-usuario-edit/0', navExtras]);
    }
  }

  viewIncidencia(id: number) {
    if (id == null || id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un incidente", "Error");
      return false;
    }

    this.router.navigate(['incidencia-usuario-edit', id]);
  }

//#endregion

//#region gerErrors messages

  getErrorAdjuntoDescripcion() {
    var v = this.formFileGroup.get('Descripcion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

  getErrorObservacion() {
    var v = this.formGroup.get('Observacion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 100 caracteres alcanzado';
    return '';
  }

  getErrorTipoMaterial() {
    return this.formGroup.get('TipoMaterialId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorComunidadOrigen() {
    return this.formGroup.get('ComunidadOrigenId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorComunidadDestino() {
    return this.formGroup.get('ComunidadDestinoId')?.hasError('required') ? 'El campo es obligatorio' :'';
  }

  getErrorPedidoHistorialDescripcion() {
    var v = this.pedidoHistorialFormGroup.get('Descripcion');
    if (v?.hasError('required'))
      return 'El campo es obligatorio';
    if (v?.hasError('maxlength'))
      return 'Límite de 150 caracteres alcanzado';
    return '';
  }

//#endregion
}
